import defaultSettings from '@/settings'

const title = defaultSettings.title || '51gp'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/admin/utils/get-page-title.js